/*
 * The dialect a chat message is written in, as one configuration of `core/editor/dialect/`: the
 * schema beside it, the tokenizer and token map of `parse.ts`, the writers of `serialize.ts`. This
 * file is the whole of the message dialect in one import; `../message.ts` builds it and is what the
 * composer uses.
 */

import type { DialectConfig } from "../dialect/index.ts"
import { messageTokenizer, TOKENS } from "./parse.ts"
import { allowedHref, LANG_SOURCE, messageMarks, messageNodes } from "./schema.ts"
import { messageWriters } from "./serialize.ts"

export const messageDialectConfig: DialectConfig = {
	name: "message",
	nodes: messageNodes,
	marks: messageMarks,
	tokenizer: messageTokenizer,
	tokens: TOKENS,
	serializer: messageWriters,
	// A heading is one line by definition, and a table row is one line, so each of its cells is too:
	// both run their content through `withoutBreaks`, and this is the list of everyone who does,
	// named beside the rule it follows from. The keymap reads it to keep a break out of a block that
	// would swallow it. A third one-line writer belongs in this list, and the editor learns of it in
	// the same move.
	oneLineBlocks: ["heading", "table_cell"],
	allowedHref,
	fenceInfo: LANG_SOURCE,
}

export { TOKENS } from "./parse.ts"
export { allowedHref } from "./schema.ts"
